export default "__VITE_ASSET__DfIad2n5__"